import { AlertBanner, Button } from '@apollo/orbit';
import React from 'react';

import { useLocalStorage } from 'src/hooks/useLocalStorage';
import { useTrackCustomEvent } from 'src/hooks/useTrackCustomEvent';

export function MigrationPendingBanner() {
  const [_, setMigrationView] = useLocalStorage('errorInsightsMigrationView');
  const trackCustomEvent = useTrackCustomEvent();

  return (
    <AlertBanner className="mb-6" status="warning">
      You are viewing a legacy version of the errors page. This view will be
      removed in a future release.{' '}
      <Button
        variant="buttonLink"
        onClick={() => {
          setMigrationView('categorized');
          trackCustomEvent({
            category: 'Operation Insights Errors',
            action: 'migration_opt_in',
          });
        }}
      >
        Try the new errors experience.
      </Button>
    </AlertBanner>
  );
}
